module.exports = __webpack_public_path__ + "fonts/FreightNeoProLight-Italic.0d543b81.otf";